// extracted by mini-css-extract-plugin
export default {"AnimationContainer":"FullPageAnimation_AnimationContainer__z7Ji7","Animation":"FullPageAnimation_Animation__T8l3W"};